import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Input } from 'antd';
import OrderTypes from './OrderTypes';
const Search = Input.Search;

const TopPanel = props => {
  const {
    typesList,
    totalOrders,
    onChangeTypeList,
    onChangeSearch,
    handleSearchOrders,
    searchValue,
    typeListValue,
    stat,
  } = props;

  return (
    <div className="b-table-filters">
      <Row>
        <Col span={18}>
          <div className="orders__states">
            <OrderTypes
              totalOrders={totalOrders}
              typesList={typesList}
              stat={stat}
              value={typeListValue}
              onChangeTypeList={onChangeTypeList}
            />
          </div>
        </Col>
        <Col span={6}>
          <Search
            placeholder="Поиск по заказам"
            onChange={onChangeSearch}
            value={searchValue}
            allowClear={true}
            onSearch={handleSearchOrders}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default connect(state => ({
  searchValue: state.Executorship.Orders.filters.search,
  typeListValue: state.Executorship.Orders.filters.typeList,
}))(TopPanel);
